import { render, staticRenderFns } from "./day-status.vue?vue&type=template&id=245718f5&"
import script from "./day-status.vue?vue&type=script&lang=js&"
export * from "./day-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports